
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.999 19.165A9.178 9.178 0 01.832 10a.833.833 0 111.667 0 7.5 7.5 0 107.5-7.5.833.833 0 110-1.667 9.167 9.167 0 010 18.333z"}}),_c('path',{attrs:{"d":"M9.999 19.165a9.175 9.175 0 01-2.709-.406.833.833 0 11.491-1.594A7.488 7.488 0 0010 17.5a.833.833 0 010 1.666zm-5.367-1.958a.833.833 0 01-.537-.195 9.146 9.146 0 01-2.263-2.847.833.833 0 011.484-.757 7.473 7.473 0 001.855 2.333.833.833 0 01-.539 1.466zm-2.847-4.953a.833.833 0 01-.82-.693 9.313 9.313 0 01.103-3.638.833.833 0 111.623.377 7.588 7.588 0 00-.083 2.98.834.834 0 01-.823.974zm1.471-6.32a.833.833 0 01-.674-1.324 9.209 9.209 0 011.922-1.95.833.833 0 111.002 1.333A7.568 7.568 0 003.93 5.59a.833.833 0 01-.674.344zM8 2.74A.833.833 0 017.795 1.1 9.237 9.237 0 0110 .832a.833.833 0 010 1.667 7.53 7.53 0 00-1.804.218.833.833 0 01-.196.024zM7.642 13.189a.834.834 0 01-.59-1.423l4.716-4.715a.833.833 0 111.178 1.179L8.23 12.945a.826.826 0 01-.59.244z"}}),_c('path',{attrs:{"d":"M12.355 13.189a.828.828 0 01-.589-.244L7.051 8.23A.833.833 0 118.23 7.05l4.715 4.715a.833.833 0 01-.59 1.423z"}})])
          )
        }
      }
    